import heroImage from '../img/corn-bliss-images/photo-2025-09-28-20-13-57-jpg.jpeg';
import heroImageAlt from '../img/corn-bliss-images/photo-2025-09-28-20-13-57-2-jpg.jpg';
import heroSectionImage from '../img/corn-bliss-images/hero section 2.png';
import heroSectionMobileImage from '../img/corn-bliss-images/hreo section 3.png';
import productOne from '../img/corn-bliss-images/200g.webp';
import productTwo from '../img/corn-bliss-images/500g.webp';
import productThree from '../img/corn-bliss-images/1000g.webp';
import productFour from '../img/corn-bliss-images/1500g.webp';
import productFive from '../img/corn-bliss-images/2500g.webp';
import customerImage from '../img/corn-bliss-images/chatgpt-image-jun-20-2025-09-34-46-pm.png';
import cornBlissLogo from '../img/corn-bliss-images/corn bliss logo.jpeg';
import whyChooseCornBlissImage from '../img/corn-bliss-images/dsc00918-jpg.jpeg';

export { heroImage, heroSectionImage, heroSectionMobileImage, customerImage, cornBlissLogo, whyChooseCornBlissImage };

export const products = [
  {
    id: 1,
    title: '200 g Sweet Corn Pack',
    titleSinhala: 'මිටු බUser 200g ඇසුරුම',
    price: 400,
    priceDisplay: 'Rs. 400.00',
    badge: 'Perfect for Singles',
    badgeColor: '#FF6B6B',
    bestFor: 'Best match for individuals or a healthy snack option.',
    bestForSinhala: 'තනි පුද්ගලයින් හෝ සෞඛ්‍ය සම්පන්න ස්නැක්ස් සඳහා සර්ව‍ෝත්තම.',
    description: '🌽 Fresh, crispy, and delicious. Individually packaged for convenience. 100% natural, no preservatives added.',
    image: productOne,
  },
  {
    id: 2,
    title: '500 g Sweet Corn Pack',
    titleSinhala: 'මිටු බUser 500g ඇසුරුම',
    price: 700,
    priceDisplay: 'Rs. 700.00',
    badge: 'Popular Choice',
    badgeColor: '#FFA500',
    bestFor: 'Best match for couples, light meals, and evening snacks.',
    bestForSinhala: 'යුවළ, සැහැල්ලු ආහාර සහ සන්ධ්‍යා ස්නැක්ස් සඳහා සර්ව‍ෝත්තම.',
    description: '🌽 Ideal for couples or small gatherings. Ready-to-eat freshness in every bite. Pure, natural, and delicious.',
    image: productTwo,
  },
  {
    id: 3,
    title: '1 kg Sweet Corn Pack',
    titleSinhala: 'මිටු බUser 1 kg ඇසුරුම',
    price: 1300,
    priceDisplay: 'Rs. 1300.00',
    badge: 'Best for Families',
    badgeColor: '#4CAF50',
    bestFor: 'Best match for families and regular meal prep.',
    bestForSinhala: 'පවුලුවලට සහ නිතිපතා ආහාර සැකසීමට සර්ව‍ෝත්තම.',
    description: '🌽 Family-sized goodness! Perfect for meal prepping and sharing. Freshly prepared with zero additives.',
    image: productThree,
  },
  {
    id: 4,
    title: 'Combo Pack Small - Special (serves 4)',
    titleSinhala: 'විශේෂ කම්බෝ ඇසුරුම - කුඩා (3 ස්වාද සමඟ)',
    price: 1500,
    priceDisplay: 'Rs. 1500',
    badge: '🎉 Special Combo',
    badgeColor: '#2196F3',
    bestFor: '3 flavors + free cups + free delivery.',
    bestForSinhala: '500g මිටු ඇතුළුව + 3 ස්වාද + නිරුපද කෝප්ස + නිරුපද බෙදා හැරීම.',
    description: '🌽 Try 3 exciting flavors! Includes 500g corn, 3 flavored sauces, cups & FREE delivery. Perfect gathering combo!',
    image: productFour,
  },
  {
    id: 5,
    title: 'Combo Pack Medium - Special(serves 7)',
    titleSinhala: 'විශේෂ කම්බෝ ඇසුරුම - මධ්‍යම (3 ස්වාද සමඟ)',
    price: 2500,
    priceDisplay: 'Rs. 2500',
    badge: '⭐ Best Value',
    badgeColor: '#9C27B0',
    bestFor: '3 flavors + cups + free delivery.',
    bestForSinhala: '1kg මිටු ඇතුළුව + 3 ස්වාද සෝස් + කෝප්ස + නිරුපද බෙදා හැරීම.',
    description: '🌽 Ultimate Party Pack! 1kg corn + 3 premium sauces + cups & FREE delivery. Best value for large groups!',
    image: productFive,
  },
  {
    id: 6,
    title: 'Corn Flakes',
    titleSinhala: 'බUser පිටි',
    price: 0,
    priceDisplay: 'Coming Soon',
    badge: '🚀 Coming Soon',
    badgeColor: '#FF9800',
    bestFor: 'A crunchy, healthy breakfast alternative.',
    bestForSinhala: 'ස්‍ටේ කිරීම සහ සෞඛ්‍ය සම්පන්න උදෙසන්න විකල්ප.',
    description: '🌽 Revolutionary breakfast! Crispy, nutritious, and 100% natural. Stay tuned for the launch!',
    image: heroImageAlt,
  },
];

export const features = [
  '100% Sri Lankan: Hand-picked from Ella & Badulla highlands.',
  'Fast & Reliable Delivery: Colombo, Gampaha, Negombo, Kalutara, Panadura, and more.',
  'Preservative-Free: Pure dehydrated corn with no added additives.',
  'Real Customer Love: 100+ happy families.',
];

export const featuresSinhala = [
  '100% ශ්‍රී ලංකා: එල්ල සහ බදුල්ල උচ්චෝත්තරයククින් අතින් එකතු කරන ලද.',
  'ඉක්මන් සහ විශ්වාසවන්ත බෙදා හැරීම: පश්චිම පළාතුවලින්, ගම්පහ ප්‍රදේශ, නෙගොම්බෝ, කලතුර, පනාදුර සහ තවත් බොහෝ ස්ථාන.',
  'සംරක්ෂක නැත: සිදු නිර්ජලිත බUser කිසිදු ඇතිරුවකින් තොරව.',
  'නැවතත් ස්වාගතයි: 100+ ස්වස්තිමත් පවුල්.',
];

export const deliveryZones = [
  {
    region: 'Western Province',
    cities: ['Colombo', 'Gampaha', 'Negombo', 'Kalutara', 'Panadura'],
  },
  {
    region: 'Uva Province',
    cities: ['Badulla Town Area'],
  },
];

export const districts = [
  'Colombo',
  'Gampaha',
  'Negombo',
  'Kalutara',
  'Panadura',
  'Badulla',
];

export const promotionalHighlights = [
  {
    title: 'නැවුම් ලෙස 100% දේශියව සකසන කරන ලද',
    titleEn: 'Freshly Prepared 100% Locally',
    emoji: '🇱🇰',
  },
  {
    title: 'කිසිදු planṇikaraṇavak නැත',
    titleEn: 'No any preservatives',
    emoji: '😍',
  },
  {
    title: 'තොරතුරු බෙදා හැරීම ඇත',
    titleEn: 'Cash on Delivery Available',
    emoji: '🚚',
  },
  {
    title: 'ඔට්ටු කෝප්ස සහ ස්වාද ඇතුළුව',
    titleEn: 'Includes Cups & Flavors',
    emoji: '🌽',
  },
];

export const testimonials = [
  {
    name: 'Koshila Liyanarachchi',
    text: 'The freshest corn I\'ve ever ordered in Colombo. No preservatives make it perfect for my kids!',
    stars: 4,
  },
  {
    name: 'Lakshan W.',
    text: 'Super fast delivery and the 1kg pack is great value for meal prep. Highly recommended.',
    stars: 5,
  },
  {
    name: 'Kasun M.',
    text: 'Best quality corn I\'ve found in Sri Lanka! The taste is amazing and it arrives fresh. Worth every rupee!',
    stars: 5,
  },
  {
    name: 'Sithara K.',
    text: 'Ordered for our restaurant and it\'s been a game changer. Consistently fresh and the team is very responsive.',
    stars: 5,
  },
  {
    name: 'Chandrika D.',
    text: 'Love that they\'re organic and chemical-free. My family feels so good eating this. Highly recommend!',
    stars: 4,
  },
  {
    name: 'Ananda M.',
    text: 'The combo pack is perfect for our family of 5. Great variety and excellent value for money!',
    stars: 5,
  },
];

export const recipes = [
  {
    title: 'Classic Butter Sweet Corn',
    description: 'Warm the corn, add butter, a pinch of salt, and serve hot.',
  },
  {
    title: 'Masala Sweet Corn',
    description: 'Mix with chilli powder, pepper, chat masala, and a touch of lime.',
  },
  {
    title: 'Lemon Pepper Sweet Corn',
    description: 'Toss with lemon juice, cracked pepper, and a tiny pinch of sea salt.',
  },
];

export const journey = [
  {
    title: 'Farming',
    description: 'Grown in Ella and Badulla highlands using traditional rain-fed methods.',
  },
  {
    title: 'Production',
    description: 'Freshly harvested, cleaned, low-temp dehydrated, and packed hygienically.',
  },
  {
    title: 'Distribution',
    description: 'Direct from the facility to your door with a chilled delivery network.',
  },
];

export const healthBenefits = [
  {
    icon: '',
    title: 'Nutrient-Rich',
    description: 'Sweetcorn is packed with essential nutrients, including vitamins B and C, potassium, and magnesium, supporting overall health and well-being.',
  },
  {
    icon: '',
    title: 'High in Fiber',
    description: 'It\'s an excellent source of dietary fiber, promoting healthy digestion and helping maintain a balanced gut.',
  },
  {
    icon: '',
    title: 'Energy Booster',
    description: 'The natural carbohydrates in sweetcorn provide long-lasting energy, making it a great addition to your meals.',
  },
  {
    icon: '',
    title: 'Antioxidant Powerhouse',
    description: 'Rich in antioxidants like lutein and zeaxanthin, sweetcorn supports eye health and helps protect against oxidative stress.',
  },
  {
    icon: '',
    title: 'Naturally Gluten-Free',
    description: 'Sweetcorn is a naturally gluten-free food, perfect for those with gluten intolerance or celiac disease.',
  },
  {
    icon: '',
    title: 'Dehydrated for Convenience',
    description: 'Enjoy all these benefits in our dehydrated sweetcorn product, which retains its nutritional value while being lightweight and easy to store!',
  },
];

export const deliveryInfo = {
  payment: {
    title: 'Cash on Delivery (COD)',
    description: 'Available for your convenience',
    icon: '🚚',
  },
  pricing: {
    basePrice: 400,
    baseWeight: 2,
    additionalPricePerKg: 100,
    description: 'Up to 2kg: Rs 400 | After that: Rs 100 per 1kg additional',
    details: [
      { weight: 'Up to 2kg', price: 'Rs 400' },
      { weight: 'Each additional 1kg', price: 'Rs 100' },
    ],
  },
  zones: [
    {
      region: 'Western Province',
      cities: ['Colombo', 'Gampaha', 'Negombo', 'Kalutara', 'Panadura'],
    },
    {
      region: 'Uva Province',
      cities: ['Badulla'],
    },
  ],
};

export const contactInfo = {
  phones: ['071 876 7144', '070 588 9291'],
  whatsapp: '+94 70 221 6486',
  email: 'blisscorn@gmail.com',
  social: {
    facebook: 'https://web.facebook.com/CornBliss1/?_rdc=1&_rdr',
    tiktok: 'https://www.tiktok.com/@cornbliss',
    instagram: 'https://www.instagram.com/cornbliss_sweetcorn/',
  },
  status: 'Always open',
};
